import React from 'react'
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import tw from "twin.macro";
import "../style.css"
import { css } from "styled-components/macro"; //eslint-disable-line
 let uni = 'https://upload.wikimedia.org/wikipedia/tr/d/d8/Bah%C3%A7e%C5%9Fehir_%C3%9Cniversitesi_logo.png'
function BAU() {
    const Subheading = tw.span`tracking-wider text-sm font-medium`;
    const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
    const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
    const Description = tw.span`inline-block mt-8`;
    const imageCss = tw`rounded-4xl`;
    const Container = tw.div`relative`;
    const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
    const Heading = tw.h1`font-black text-black text-3xl md:text-5xl  max-w-3xl`;


  return (
    <AnimationRevealPage>
         <Hero
        heading={<><HighlightedText>Bahçeşehir University (BAU)</HighlightedText></>}
        description="Founded in 1998 by the Bahçeşehir Uğur Educational Foundation, BAU is a globally connected university known for its international collaborations. With the motto A World University in the Heart of Istanbul, BAU offers diverse academic programs.  "
        imageSrc={uni}
        imageCss={imageCss}
        imageDecoratorBlob={true}
    
      />
            <Container>
      <TwoColumn>
<Heading>Students</Heading>
</TwoColumn>
</Container>
      <Container>
      <TwoColumn>
    


   
      <div className="table-container">
    <table>
        <thead>
            <tr>
                <th>Name</th>
                <th>Department</th>
                <th>University Entrance Year</th>
                <th>FIRST Team Number - Name</th>
                <th>FIRST Programs Participated</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>  Mehmet Batuhan Şengün </td>
                <td>   Digital Game Design  </td>
                <td>2018</td>
                <td>       6415 - 8159 - 7458 </td>
                <td>FRC</td>
            </tr>
            <tr>
                <td>Alara Şimşek </td>
                <td> Visual Communication Design  </td>
                <td>2022</td>
                <td> 7576</td>
                <td>FRC</td>
            </tr>
          
        
        </tbody>
    </table>
</div>

</TwoColumn>
</Container>
<Footer />
        </ AnimationRevealPage>
  )
}

export default BAU